<div class="content__text__info {{fontSize}}" [innerHTML]="textToDisplay"></div>

<div class="action-buttons" *ngIf="!hideButtonActionsForReviewer">
    <div *ngIf="!hideLanguageStyleOptions">
        <div *ngIf="temporaryLanguageStyleSelected !== languageStyleStandard" class="language-style-btn">
            <app-button [cssClasses]="'btn slim solid__white'"
                        [ariaLabel]="('GENERAL.READ_INFORMATION_STANDARD' | translate) + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="selectLanguageStyle(languageStyleStandard)">
                {{'GENERAL.READ_INFORMATION_STANDARD' | translate}}
            </app-button>
        </div>

        <div *ngIf="temporaryLanguageStyleSelected !== languageStyleSimple" class="language-style-btn">
            <app-button [cssClasses]="'btn slim solid__white'"
                        [ariaLabel]="('GENERAL.READ_INFORMATION_SIMPLE' | translate) + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="selectLanguageStyle(languageStyleSimple)">
                {{'GENERAL.READ_INFORMATION_SIMPLE' | translate}}
            </app-button>
        </div>

        <div *ngIf="temporaryLanguageStyleSelected !== languageStyleEasy && enableEasyLanguageStyle"
             class="language-style-btn">
            <app-button [cssClasses]="'btn slim solid__white'"
                        [ariaLabel]="('GENERAL.READ_INFORMATION_EASY' | translate) + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="selectLanguageStyle(languageStyleEasy)">
                {{'GENERAL.READ_INFORMATION_EASY' | translate}}
            </app-button>
        </div>
    </div>

    <div class="comment-btn" *ngIf="enableCommenting">
        <app-button
                [cssClasses]="'btn slim solid__white'"
                [icon]="'chat_bubble'"
                [disabled]="this.commentHereButtonDisabled"
                [ariaLabel]="('CONSENT.COMMENTS.ASK_DOCTOR_A_QUESTION' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="openCommentMenu()">
            {{'CONSENT.COMMENTS.ASK_DOCTOR_A_QUESTION' | translate}}
        </app-button>
    </div>
</div>

